// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_tt-0";
export var checkoutRateBadgeLink = "_tt-1";